import { Add, Handyman, UploadFile } from '@mui/icons-material'
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material'
import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useAppDispatch, useAppSelector } from '../../../../Redux/store'
import { setNextDisabled } from '../Slices/TalentProfileCreationSlice'

export const CreatingProfile = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container display={"flex"} flexDirection={"column"} gap={"8px"}>
            <Box sx={{position: 'relative'}}>
                <Handyman />
                <CircularProgress
                    size={38}
                    sx={{
                    color: 'primary.main',
                    position: 'absolute',
                    top: -7,
                    left: -7,
                    zIndex: 1,
                    }}
                />
            </Box>
            <Typography variant={'lora-title-large'} fontWeight={"bold"} color={'primary'}>Please wait...</Typography>  
            <Typography variant={'body-medium'} color={'black.400'}>We’re getting your profile ready. This will only take a moment.</Typography>
        </Grid>
    )
}